export default function useGuest () {
  const store = useGuestStore()
  const { user, isLoggedIn } = storeToRefs(store)

  return {
    user: user,
    isLoggedIn: isLoggedIn,
    loginWithGoogle: store.loginWithGoogle,
    loginWithCognito: store.loginWithCognito,
    confirmSignUp: store.confirmSignUp,
    resendSignUpConfirmationCode: store.resendSignUpConfirmationCode,
    sendPasswordResetCode: store.sendPasswordResetCode,
    confirmPasswordReset: store.confirmPasswordReset,
    logout: store.logout,
    getSession: store.getSession,
    updateProfile: store.updateProfile,
    deleteAccount: store.deleteAccount
  }
}
